// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c007b81c","732":"aed7d6f7","977":"67430a76"}[chunkId] + ".chunk.js";
};